import React from 'react';
import { observer } from 'mobx-react-lite';
import { Alert } from 'src/domains/common/components/alert/alert';
import { Button } from 'src/domains/common/components/button/button';
import { SourceOfFundsState } from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFunds.state';
import {
    SourceOfFundsActions,
    SourceOfFundsSection,
    SourceOfFundsSectionTitle,
    SourceOfFundsTestTriggerField,
    SourceOfFundsTestTriggerInput,
    SourceOfFundsTestTriggerLabel,
} from 'src/components/ComplianceConfiguration/SourceOfFunds/SourceOfFunds.style';

interface SourceOfFundsTestTriggerPanelPropsType {
    state: SourceOfFundsState;
}

export const SourceOfFundsTestTriggerPanel = observer(
    ({ state }: SourceOfFundsTestTriggerPanelPropsType): JSX.Element | null => {
        if (!state.isTestTriggerAvailable) {
            return null;
        }

        return (
            <SourceOfFundsSection data-test='source-of-funds-test-trigger-panel'>
                <SourceOfFundsSectionTitle>Test automation</SourceOfFundsSectionTitle>

                <Alert
                    icon='info'
                    title='Runs the saved threshold trigger automation on a specific account. Use only for testing in non-production environments.'
                    variant='default'
                />

                {state.triggerFeedbackMessage === null ? null : (
                    <Alert
                        icon='info'
                        title={state.triggerFeedbackMessage}
                        variant={state.triggerFeedbackVariant}
                    />
                )}

                <SourceOfFundsTestTriggerField>
                    <SourceOfFundsTestTriggerLabel htmlFor='source-of-funds-test-account-id'>
                        Account ID
                    </SourceOfFundsTestTriggerLabel>
                    <SourceOfFundsTestTriggerInput
                        data-test='source-of-funds-test-account-id'
                        id='source-of-funds-test-account-id'
                        inputMode='numeric'
                        onChange={(event): void => {
                            state.setTestAccountId(event.target.value);
                        }}
                        placeholder='Enter account ID'
                        type='text'
                        value={state.testAccountId}
                    />
                </SourceOfFundsTestTriggerField>

                <SourceOfFundsActions>
                    <Button
                        dataTest='source-of-funds-trigger-automation'
                        disabled={!state.canTriggerAutomation}
                        isLoading={state.isTriggering}
                        onClick={(): void => {
                            void state.triggerAutomation();
                        }}
                        type='button'
                        variant='outline'
                    >
                        Trigger automation
                    </Button>
                </SourceOfFundsActions>
            </SourceOfFundsSection>
        );
    }
);
